import * as React from 'react';
import { buildClassString } from '@ps/payscale-shared-ui/lib/StringUtils';
import './fadeComponent.scss';

interface FadeComponentProps {
    children?: React.ReactNode;  // children to be faded in/out
    className?: string;                           // className to be applied to component/wrapper
    fadeDuration?: number;                        // duration of fade animation (in ms)
    fadeDelay?: number;                           // amount of time to delay before animating (in ms)
    show: boolean;                                // whether a show (fade-in) or hide (fade-out) animation
}

interface FadeComponentState {
    transitioning: boolean;
}

class FadeComponent extends React.PureComponent<FadeComponentProps, FadeComponentState> {
    static defaultProps: FadeComponentProps = {
        fadeDuration: 250,
        fadeDelay: 0,
        show: true
    };

    private _elt: HTMLElement | null;

    constructor(props: FadeComponentProps) {
        super(props);
        this.state = Object.assign({}, this.state, { transitioning: false });
    }

    componentDidMount(): void {
        // For flexibility, only have CSS transitions set when we
        // need it/the item is in the process of being shown/hidden
        if (this._elt) {
            this._elt.addEventListener('transitionend', () => {
                this.setState({transitioning: false});
            });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: FadeComponentProps): void {
        // if we're transitioning visibility, set the transition class
        // on the DIV to use CSS transitions
        if (nextProps.show !== this.props.show) {
            this.setState({transitioning: true});
        }
    }

    render(): React.ReactNode {
        const { children, show, fadeDuration, fadeDelay, className } = this.props;
        const { transitioning } = this.state;
        let classString = buildClassString({
            'fade-component': true,
            'show': show,
            'transition': transitioning
        });

        if (className) {
            classString += ` ${className}`;
        }

        const styleDict = {
            transitionDuration: `${fadeDuration}ms`,
            transitionDelay: `${fadeDelay}ms`
        };

        return (
            <div
                className={classString}
                style={styleDict}
                ref={elt => this._elt = elt}
            >
                {(show || transitioning) && children}
            </div>
        );
    }
}

export { FadeComponent };
export default FadeComponent;



// WEBPACK FOOTER //
// ./src/components/common/fadeComponent.tsx